import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CustomWishlistAdapter } from '../conectors/whislist.adapter';
import { Wishlist } from '../wishlist.model';



@Injectable()
export class CustomOccWishlistAdapter implements CustomWishlistAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
  ) {
  }

  loadWishlist(userId: string): Observable<Wishlist> {
    const url = this.occEndpoints.buildUrl('getWishlist', { urlParams: { userId } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get<Wishlist>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((wishlist) => {
          return wishlist;
        }
        )
      );
  }

  createWishlist(userId: string, productCode: string): Observable<Wishlist> {
    const url = this.occEndpoints.buildUrl('createWishlist', { urlParams: { userId, productCode } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<Wishlist>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((wishlist) => {
          return wishlist;
        }
        )
      );
  }

  deleteWishlist(userId: string, productCode: string): Observable<any> {
    const url = this.occEndpoints.buildUrl('createWishlist', { urlParams: { userId, productCode } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.delete<Wishlist>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((wishlist) => {
          return wishlist;
        }
        )
      );
  }
}
